<template>
  <div>
    <b-row
      class="d-flex flex-column flex-sm-row align-items-center justify-content-between px-2 px-sm-0 my-3 container"
    >
      <div class="d-flex flex-nowrap align-items-center my-4">
        <p class="current-step-icon">{{ index }}</p>
        <h3 class="title mt-1">{{ title }} <span :class="`${required ? 'required-star-in-title' : ''}`"></span></h3>
      </div>
    </b-row>
    <div :class="`section-wrapper text-left mb-4 ${hideBackground ? 'no-background' : ''} `">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    index: { type: String, required: true },
    title: { type: String, required: true },
    hideBackground: { type: Boolean, required: false },
    required: { type: Boolean, required: false }
  }
}
</script>

<style lang="scss" scoped>
.current-step-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 56px;
  height: 56px;
  background-color: #00903c;
  color: #fff;
  border-radius: 50%;
  margin-right: 25px;
  margin-bottom: 0;
  font-weight: 700;
  font-size: 32px;
  position: relative;
  left: 0 !important;
}

.section-wrapper {
  background-color: #f7fbfc;
  padding: 60px 72px;
  border-radius: 8px;
}

.no-background {
  background-color: unset !important;
}

.title {
  font-weight: 700;
  font-size: 32px;
  text-align: left;
}

.description {
  font-weight: 500;
  font-size: 12px;
  max-width: 800px;
}

.required-star-in-title:before {
  content: '*';
  color: black;
  font-size: 24px;
  margin-left: 3px;
}

@media screen and (max-width: 1200px) {
  .title {
    font-size: 24px;
  }
}

@media screen and (max-width: 390px) {
  .section-wrapper {
    padding: 24px 16px !important;
  }
}

@media screen and (max-width: 992px) {
  .section-wrapper {
    padding: 24px;
  }
}

@media screen and (max-width: 1200px) {
  .section-wrapper {
    padding: 40px;
  }
}
@media screen and (max-width: 576px) {
  .title {
    font-size: 20px;
  }
  .container {
    flex-direction: unset !important;
  }
}
</style>
